import _ from "lodash";
import {__} from "./__";

export const getAiModels = (models) => _.reduce(models, (result, model) => {
    let modelText = model;

    switch (model) {
        case 'gpt-5.6-luna':
            modelText = `${model} - ${__('Jednoduché generovania textov, preklady - nízka cena + Rozmýšla pred odpoveďou')}`;
            break;

        case 'gpt-5.6-terra':
            modelText = `${model} - ${__('Zlatá stredná cesta + Rozmýšla pred odpoveďou')}`;
            break;

        case 'gpt-5.6-sol':
            modelText = `${model} - ${__('Komplexnejšie úlohy - vyššia cena + Rozmýšla pred odpoveďou')}`;
            break;

        case 'gpt-5-nano':
            modelText = `${model} - ${__('Jednoduché generovania textov, preklady - nízka cena + Rozmýšla pred odpoveďou, vyššia cena ako jeho ekvivalent 4.1-nano')}`;
            break;

        case 'gpt-5-mini':
            modelText = `${model} - ${__('Zlatá stredná cesta + Rozmýšla pred odpoveďou, vyššia cena ako jeho ekvivalent 4.1-mini')}`;
            break;

        case 'gpt-5':
            modelText = `${model} - ${__('Komplexnejšie úlohy - vyššia cena + Rozmýšla pred odpoveďou, vyššia cena ako jeho ekvivalent 4.1')}`;
            break;

        case 'gpt-4.1-nano':
            modelText = `${model} - ${__('Jednoduché generovania textov, preklady - nízka cena')}`;
            break;

        case 'gpt-4.1-mini':
            modelText = `${model} - ${__('Zlatá stredná cesta')}`;
            break;

        case 'gpt-4.1':
            modelText = `${model} - ${__('Komplexnejšie úlohy - vyššia cena')}`;
            break;
    }

    return { ...result, [model]: modelText };
}, {});
